"use client";

import { useState, useEffect, useRef } from "react";
import Link from "next/link";
import { Swiper, Button } from "react-vant";
import { Arrow } from "@react-vant/icons";
import ProductItem from "@/components/global/ProductItem";
import hottestDealsApi from "@/service/modules/hottestDealsApi";
import type { ProductType } from "@/types/product";
import styles from "@/styles/hottest-deals/crazy-top-sellers.module.scss";

export default function FeaturedDeals() {
  const [featuredDealsData, setFeaturedDealsData] = useState<ProductType[]>([]);
  const swiperRef = useRef<any>(null);

  // 获取Featured Deals模块数据
  async function getFeaturedDealsData() {
    try {
      const resData = await hottestDealsApi.getFeaturedDeals();

      if (resData.data && resData.data.length) {
        // 整理图片
        resData.data.forEach((item: ProductType) => {
          item.imgUrl = item.filename || item.newThumbnail;
        });

        setFeaturedDealsData(resData.data);
      }
    } catch (error) {
      console.log(`Featured Deals模块数据 `, error);
    }
  }

  useEffect(() => {
    // 获取Featured Deals模块数据
    getFeaturedDealsData();
  }, []);

  // 将数组按每4个分组
  const groupProducts = (products: ProductType[], groupSize: number = 4): ProductType[][] => {
    const groups: ProductType[][] = [];
    for (let i = 0; i < products.length; i += groupSize) {
      groups.push(products.slice(i, i + groupSize));
    }
    return groups;
  };

  const groupedProducts = groupProducts(featuredDealsData, 4);

  // 只有当有数据时才渲染 Swiper
  if (!featuredDealsData || featuredDealsData.length === 0) {
    return null;
  }

  return (
    <div className={styles["comp-crazy-top-sellers"]}>
      <div className={styles["title"]}>Featured Deals</div>
      <div className={styles["swiper-wrapper"]}>
        <Swiper 
          ref={swiperRef}
          autoplay={4000} 
          loop={false}
        >
          {groupedProducts.map((group, groupIndex) => (
            <Swiper.Item key={groupIndex}>
              <div className={styles["product-group-featured"]}>
                {group.map((product) => (
                  <ProductItem key={product.productID} product={product} />
                ))}
              </div>
            </Swiper.Item>
          ))}
        </Swiper>
        <div 
          className={styles["swiper-wrapper-prev"]}
          onClick={() => swiperRef.current?.swipePrev()}
        >
          <Arrow className={styles["prev-icon"]} rotate={180} />
        </div>
        <div 
          className={styles["swiper-wrapper-next"]}
          onClick={() => swiperRef.current?.swipeNext()}
        >
          <Arrow className={styles["next-icon"]} rotate={0} />
        </div>
      </div>

      <Link href="/featured-deals">
        <Button
          type="primary"
          style={{ 
            width: '50%',
            margin: '0 auto 6px auto'
          }}
          block
        >
          View All
        </Button>
      </Link>
    </div>
  );
}
